export default "__VITE_ASSET__CNiAPWVb__"